import IconSearch from "../../components/icon/IconSearch";
import React from "react";

type PropTypes = {
  onSearch: (value: string) => void;
  value?: string;
};

export default function TableSearch({ onSearch, value }: PropTypes) {
  return (
    <>
      <div className="mt-1 relative rounded-md shadow-sm">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <IconSearch className="h-5 w-5 text-gray" aria-hidden="true"/>
        </div>
        <input name="search" type="text" placeholder="Search" value={value}
               onChange={(e) => onSearch(e.target.value)}
               className="pl-10 py-2 focus:border-blue-focus block border-gray border rounded-md w-96"/>
        {value && value.length > 0 &&
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer text-gray-dark"
            onClick={() => onSearch("")}>
            <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </div>
        }
      </div>
    </>
  );
}
